import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'
import icon from '@/assets/dsig_icon.webp'
import {
	VirtualBadgeButton,
	VirtualBadgeModal,
} from '@/components/virtual-badge'
import { ROUTES } from '@/constants/routes'
import { NoticeBell } from './notice-bell.tsx'
import { UserMenu } from './user-menu'

export const Header = () => {
	const { t } = useTranslation()
	return (
		<header className="border-kaefer-silver border-b bg-kaefer-dark-grey text-white shadow-sm">
			<div className="px-4 py-2 md:px-6 md:py-3">
				<div className="flex items-center justify-between gap-2">
					{/* Logo Section */}
					<Link
						className="group flex items-center gap-2 md:gap-3"
						to={ROUTES.DASHBOARD.HOME}
					>
						{/* Selo da águia — anima no hover */}
						<span className="relative block h-8 w-8 rounded-full transition-[filter] duration-300 group-hover:drop-shadow-[0_0_8px_rgba(220,30,30,0.8)] motion-safe:group-hover:animate-[eagle-look_0.9s_ease-out_forwards] md:h-9 md:w-9">
							<img alt="" className="h-full w-full" src={icon} />
							{/* Pálpebra posicionada sobre o olho do ícone */}
							<span className="pointer-events-none absolute top-[30.3%] left-[53.1%] h-[7.5%] w-[10%] -translate-x-1/2 -translate-y-1/2 scale-y-0 rounded-full border-[#78603c] border-b bg-[#2d2218] motion-safe:group-hover:animate-[eagle-blink_0.7s_ease-in-out_0.9s]" />
							<span className="pointer-events-none absolute inset-0 overflow-hidden rounded-full">
								<span className="absolute inset-y-0 left-0 w-1/2 -translate-x-[150%] bg-linear-to-r from-transparent via-white/60 to-transparent motion-safe:group-hover:animate-[eagle-shine_0.7s_ease-in-out_0.15s]" />
							</span>
						</span>
						<span className="font-bold text-base text-white md:text-lg tracking-wide">
							{t('header.title')}
						</span>
					</Link>

					{/* Right Section */}
					<div className="flex h-10 items-center gap-2 md:h-8 md:gap-3">
						{/* Crachá virtual (DDS) */}
						<VirtualBadgeButton />

						{/* Notifications */}
						<NoticeBell />

						{/* User Menu */}
						<UserMenu />
					</div>
				</div>
			</div>
			<VirtualBadgeModal />
		</header>
	)
}
